import { FC } from 'react';
import { useForm, withForm } from 'react-bootstrap-formutil';
import { getFullName } from 'components/forms/RealNameInfo';
import RevenueForm from 'components/forms/RevenueForm';
import { usePowerNavigate } from 'components/PowerNavigate';
import security from 'stores/security';
import values from 'stores/values';
import { CustomerInfoType } from 'types/customer';
import Container from '../components/Container';

const Revenue: FC = () => {
    const { $params } = useForm<CustomerInfoType>();
    const navigate = usePowerNavigate();

    return (
        <Container
            onSubmit={() => navigate('../agreements')}
            footerButtonsProps={{
                hidePrev: false,
                nextBtnProps: {
                    content: __('继续')
                }
            }}>
            <RevenueForm name={getFullName($params)} customerInfo={$params} disabled />
        </Container>
    );
};

export default withForm(Revenue, {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
